import { render, staticRenderFns } from "./MatchSlotsStep.vue?vue&type=template&id=edfb7514"
import script from "./MatchSlotsStep.vue?vue&type=script&lang=js"
export * from "./MatchSlotsStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports